import React, { useState } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart } from '../../ducks/cart.duck';
import { FormattedMessage } from 'react-intl';
import { string } from 'prop-types';

import IconPlus from '../../containers/SearchPage/IconPlus/IconPlus';

import css from './ButtonAddToCart.module.css';

const ButtonAddToCart = (props) => {
    const {
        className,
        rootClassName,
        listingId,
    } = props;
    const dispatch = useDispatch();
    const [isAddingToCart, setIsAddingToCart] = useState(false);
    const { cartItems } = useSelector(state => state.cart);
    const classes = classNames(rootClassName || css.root, className);

    // Simplified check: biocerca might use listing object directly or ID. 
    // Comparing against cartItems array.
    const isItemInCart = cartItems.find(item => {
        const id = item.id?.uuid || item.id;
        return id === listingId;
    });

    const handleClickAddToCart = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (!isItemInCart) {
            setIsAddingToCart(true);
            dispatch(addToCart(listingId)).then(() => {
                setIsAddingToCart(false);
            });
        }
    };

    const buttonText = isItemInCart ? (
        <FormattedMessage id="ButtonAddToCart.addedToCart" />
    ) : isAddingToCart ? (
        <FormattedMessage id="ButtonAddToCart.addingToCart" />
    ) : (
        <>
            <IconPlus isOpen={false} className={css.iconPlus} />
            <FormattedMessage id="ButtonAddToCart.addToCart" />
        </>
    )

    return (
        <div className={classes} onClick={handleClickAddToCart}>
            {buttonText}
        </div>
    );
}

ButtonAddToCart.defaultProps = {
    rootClassName: null,
    className: null,
};

ButtonAddToCart.propTypes = {
    rootClassName: string,
    className: string,
    listingId: string.isRequired,
}

export default ButtonAddToCart;
